module.exports = __webpack_public_path__ + "img/home-service-qixiang.b23408d2.png";